import { queryOptions } from '@tanstack/react-query';

import { getUserSettings } from '@/lib/firebase/store';

export const userSettingsQueryKey = (userId: string | null) => ['user', 'settings', userId] as const;

export const userSettingsQueryOptions = (userId: string | null) =>
  queryOptions({
    queryKey: userSettingsQueryKey(userId),
    queryFn: async () => {
      if (!userId) return null;

      return getUserSettings(userId);
    },
    enabled: !!userId,
    // The snapshot listener in the user-settings observer is the sole source of invalidation.
    staleTime: Number.POSITIVE_INFINITY,
  });
